<template>
  <div>
    <v-breadcrumbs class="px-0" :items="items"></v-breadcrumbs>
<!--    <loading :active.sync="isLoading" :is-full-page="true"></loading>-->
    <v-row>
      <v-col>
        <Layout1 />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Layout1 from "../../components/article_layout/Layout1";
import { mapState } from "vuex";
// import Loading from 'vue-loading-overlay';
import { BreadcrumbUtil } from "@/util/BreadcrumbUtil";
import { setMetaTags } from "@/util/Constants";
// import Layout2 from "../../components/article_layout/Layout2";

export default {
  components: {
    Layout1,
    // Loading
    // Layout2 // TODO :: didn't see it's on design
  },
  async created() {
    this.items = BreadcrumbUtil.setServiceItem(
        this.items,
        this.branchId,
        this.branchName,
        this.allBranches,
        this.lang
    )
    this.isLoading = true;
    let id = this.$route.params.slug_id.split('-')[0]
    await this.$store.dispatch('Article/onGetArticleById', { id: id, lang: this.lang });
    setMetaTags(document, window, this.article[`subject_${this.lang}`], this.article[`intro_${this.lang}`], this.article.cover_img_path)
    this.$store.dispatch('Article/onCountArticleView', id);
    this.isLoading = false;
  },
  computed: {
    ...mapState({
      branchName: state => state.Branch.branch_name,
      allBranches: state => state.Branch.branches,
      branchId: state => state.Branch.branch_id,
      lang: state => state.Branch.lang,
      article: state => state.Article.article
    }),
    branchChanged: function () {
      return this.branchName;
    }
  },
  watch: {
    branchChanged: function() {
      this.items = BreadcrumbUtil.setServiceItem(
          this.items,
          this.branchId,
          this.branchName,
          this.allBranches,
          this.lang
      )
    }
  },
  data: () => ({
    item: {
      id: 1,
      layout: 1
    },
    isLoading: false,
    items: [
      {
        text: 'TCDC BANGKOK',
        disabled: false,
        to: "/home/:branch"
      },
      {
        text: "SERVICE",
        disabled: false,
        to: "/:branch/service"
      },
      {
        text: "RESOURCE CENTER",
        href: "/:branch/service/resource-center"
      },
      {
        text: "ARTICLE",
        href: "/:branch/service/resource-center/article"
      }
    ]
  })
};
</script>

<style>
</style>
